import {
  GET_ATENCION_SIN_TURNO,
  GET_ATENCION_SIN_TURNO_FAIL,
  GET_ATENCION_SIN_TURNO_SUCCESS,
  GET_CENTROS,
  GET_CENTROS_FAIL,
  GET_CENTROS_SUCCESS,
  
} from "../ActionTypes";


const atencionSinTurno = (state, { payload, type }) => {
  switch (type) {
    case GET_ATENCION_SIN_TURNO:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          loading: true,
          error: false,
          data: false,
        },
      };
    case GET_ATENCION_SIN_TURNO_SUCCESS:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case GET_ATENCION_SIN_TURNO_FAIL:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          loading: false,
          error: payload,
          data: false,
        },
      };
    case GET_CENTROS:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          centros: [],
          loading: true,
        },
      };
    case GET_CENTROS_SUCCESS:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          centros: payload,
          loading: false,
        },
      };
    case GET_CENTROS_FAIL:
      return {
        ...state,
        atencionSinTurno: {
          ...state.atencionSinTurno,
          centros: [],
          loading: false,
          error: false,
        },
      };
    default:
      return state;
  }
};

export default atencionSinTurno;
